import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Standard } from 'components/Page';
import config from './config';

/*
 ** @description Prepare data for API
 ** @returns object
 */
const handlePrepareData = ({
  active, name, validity_period, id, competency_type, description
}) => ({
  id,
  name,
  competency_type_id: competency_type.key,
  active,
  validity_period,
  description
});
const Competencies = ({ permissions }) => (
  <Standard
    canAdmin={permissions.CanAdminCompetencies()
      .hasPermissions()}
    reducer={{
      item: REDUCER_KEY.competency,
      list: REDUCER_KEY.competencies
    }}
    config={config}
    onPrepareData={handlePrepareData}
    permissions={permissions}
    filterSettings={{
      reducerKey: 'competencyCollectionValues',
      placeholder: 'competency details',
      themeName: 'competency',
      showClearButton: false
    }}
  />
);

Competencies.propTypes = {
  permissions: PropTypes.object.isRequired
};

export default Competencies;
